import React, { useEffect, useState } from 'react';
import Button from '../../fields/Button';
import { GLOBAL_VARIABLES } from '../../../../utilites/variables';
import { HandleFormData } from '../../../../utilites';
import { useDispatch, useSelector } from 'react-redux';
import allActions from '../../../../Store/action';

const MiscellaneousBusinessCurrentClientShort = () => {

    const { MiscellaneousBCCShort } = GLOBAL_VARIABLES;

    const uploadFormData = HandleFormData({ parentIndex: 0, myIndex: 4, redirect: '/dashboard'  });
    const dispatch = useDispatch()
    const [{ taxPayerForm, taxPayerFormData, formInformation }, { LoginData }] = useSelector((state) => [state.taxForms, state.user]);

    const [specificQuestions, setSpecificQuestions] = useState([]);

    const [errors, setErrors] = useState({}); // Track errors for form fields

    useEffect(() => {
        setSpecificQuestions(JSON.parse(JSON.stringify(MiscellaneousBCCShort)));
    }, [MiscellaneousBCCShort]);

    const handleRadioChange = (index, value) => {
        const updatedQuestions = [...specificQuestions];
        updatedQuestions[index].bool = value;
        setSpecificQuestions(updatedQuestions);
    };

    useEffect(() => {
        if (taxPayerForm?.data?.MiscellaneousBusinessCurrentClientShort) {
            if (Object.keys(taxPayerForm?.data?.MiscellaneousBusinessCurrentClientShort).length === 0) return;
            const {
                specificQuestions,
            } = taxPayerForm?.data?.MiscellaneousBusinessCurrentClientShort;
            setSpecificQuestions(specificQuestions);
        }
    }, [taxPayerForm?.data?.MiscellaneousBusinessCurrentClientShort]);

    const check_Validity = () => {
        setErrors({});
        const newErrors = {};

        // Add more validation rules as needed for other fields
        if (
            specificQuestions
                ?.flatMap((data) => {
                    return data?.bool;
                })
                .includes(null)
        ) {
            newErrors.AnswerOtherQuestions = 'Please Select Required Option';
        }

        setErrors(newErrors);

        let ConditionCheck = Object.keys(newErrors).length === 0 ? false : true;
        // Check if there are any errors
        return ConditionCheck;
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        let errors = check_Validity();
        if (errors) return;

        let FormObj = {
            specificQuestions,
        };

        let formData = taxPayerForm;
        taxPayerForm.data.MiscellaneousBusinessCurrentClientShort = FormObj;
        dispatch(allActions.taxForms.StoreFormData({ formData }));
        // last one to submit
        let obj = {
            service_id: 1,
            method: 'upload',
            formName: formInformation?.name,
            formData: taxPayerForm.data,
        };
        if (LoginData?.isTaxPro || LoginData?.isAdmin || LoginData?.isAccountManager)
            obj.lead_id = formInformation?.lead_id;

        changeLoading(true);
        dispatch(allActions.dashboard.resetTaxPreparation());
        dispatch(allActions.dashboard.taxPreparation({ obj }));

        uploadFormData(formData);
    };

    const changeLoading = (status) => {
        dispatch(allActions.global.Loader(status));
    };

    const goBack = () => {
        // CHANGE FORM TO BACK
        let parentIndex = 0;
        let myIndex = 4;
        dispatch(allActions.taxForms.moveToBack({ parentIndex, myIndex, taxPayerFormData }));
    };

    return (
        <form className="w-100 mt-3" onSubmit={handleSubmit}>
            {/* <small className="ml-4 fw-bold">General Information</small>
            <hr className="m-0" /> */}
            <div className="mt-3 row justify-content-between px-3 custom-left-form">
                {specificQuestions.map((data, i) => {
                    return (
                        <>

                            {(i >= 0 && i <= 2) && <small className="ml-4 fw-bold">
                                {data.question}
                                {data.bool === null && (
                                    <span className="text-danger small-text mx-1">*Required</span>
                                )}
                            </small>}

                            {(i >= 0 && i <= 2) && <div className="col-md-12 my-2">
                                <input
                                    onChange={() => handleRadioChange(i, true)}
                                    checked={specificQuestions[i].bool === true}
                                    className="form-check-input"
                                    type="radio"
                                    id={`checkbox-${i + 176}`}
                                    name={`checkbox-${i + 176}`}
                                />
                                <label htmlFor={`checkbox-${i + 176}`} role="button" className="px-3 m-0 small">
                                    Yes
                                </label>
                                <input
                                    onChange={() => handleRadioChange(i, false)}
                                    checked={specificQuestions[i].bool === false}
                                    className="form-check-input"
                                    type="radio"
                                    id={`checkbox-${i + 999}`}
                                    name={`checkbox-${i + 999}`}
                                />
                                <label htmlFor={`checkbox-${i + 999}`} role="button" className="px-3 m-0 small">
                                    No
                                </label>
                            </div>}
                        </>
                    )
                })}
            </div>
            {Object.keys(errors)
                ?.map((key) => {
                    return errors[key];
                })
                ?.map((data, index) => {
                    return (
                        <>
                            <small className="text-primary" key={index}>
                                {data}*
                            </small>
                            <br />
                        </>
                    );
                })}
            <div className="container-fluid content-row pb-4">
                <div className="d-flex align-items-center justify-content-center row">
                    <Button
                        mainClass="btn btn-info custon-button-text w-100 text-dark"
                        buttonText="Previous"
                        wrapperClass={'w-25 custon-button mt-4'}
                        type="button"
                        callback={() => goBack()}
                    />
                    <Button
                        mainClass="btn btn-primary custon-button-text w-100"
                        buttonText="Submit"
                        wrapperClass={'w-25 custon-button mt-4'}
                        type="submit"
                        disabled={!formInformation?.lead_id}
                    />
                </div>
            </div>
        </form>
    );
};

export default MiscellaneousBusinessCurrentClientShort;